import type { Dispatch } from 'redux';
import { createActionFactory, Feature } from '../../../../shared';

export const deletedItemsSubViewToggleClickedAction = createActionFactory<{}>(
    'DeletedItemsSubViewToggleClicked',
    Feature.HardDelete
);

export const deletedItemsSubViewToggleClicked = (dispatch: Dispatch) =>
    dispatch(deletedItemsSubViewToggleClickedAction());
export type { Action } from '../../../../shared';
